import { Language } from '../types/language';

interface RenovationRate {
  rate: number;
  label: {
    en: string;
    fr: string;
  };
  description?: {
    en: string;
    fr: string;
  };
}

export const RENOVATION_RATES: Record<string, RenovationRate> = {
  demolition: { 
    rate: 51,
    label: {
      en: 'Demolition work',
      fr: 'Travaux de démolition'
    },
    description: {
      en: "Property's size in square meters",
      fr: "Taille de la propriété en mètres carrés"
    }
  },
  plumbing: { 
    rate: 65,
    label: {
      en: 'Plumbing work',
      fr: 'Travaux de plomberie'
    },
    description: {
      en: "Property's size in square meters",
      fr: "Taille de la propriété en mètres carrés"
    }
  },
  electricity: { 
    rate: 129,
    label: {
      en: 'Electricity work',
      fr: 'Travaux d\'électricité'
    },
    description: {
      en: "Property's size in square meters",
      fr: "Taille de la propriété en mètres carrés"
    }
  },
  floorConcreting: { 
    rate: 95,
    label: {
      en: 'Floor concreting',
      fr: 'Bétonnage du sol'
    }
  },
  floorLeveling: { 
    rate: 22,
    label: {
      en: 'Floor leveling layer',
      fr: 'Ragréage du sol'
    }
  },
  bathroomWaterproofing: { 
    rate: 19,
    label: {
      en: 'Bathroom waterproofing',
      fr: 'Étanchéité salle de bain'
    }
  },
  floorTiles: { 
    rate: 49,
    label: {
      en: 'Laying floor tiles',
      fr: 'Pose de carrelage sol'
    }
  },
  wallTiles: { 
    rate: 79,
    label: {
      en: 'Laying wall tiles',
      fr: 'Pose de carrelage mural'
    }
  },
  parquet: { 
    rate: 47,
    label: {
      en: 'Parquet laying',
      fr: 'Pose de parquet'
    }
  },
  wallPlastering: { 
    rate: 18,
    label: {
      en: 'Wall & Ceiling plastering',
      fr: 'Plâtrage murs & plafonds'
    }
  },
  wallLuting: { 
    rate: 17,
    label: {
      en: 'Wall & Ceiling luting',
      fr: 'Enduit murs & plafonds'
    }
  },
  wallPainting: { 
    rate: 15,
    label: {
      en: 'Wall & Ceiling painting',
      fr: 'Peinture murs & plafonds'
    }
  },
  suspendedCeilings: { 
    rate: 79,
    label: {
      en: 'Suspended ceilings',
      fr: 'Faux plafonds en BA-13'
    }
  },
  wallConstruction: { 
    rate: 69,
    label: {
      en: 'Wall construction',
      fr: 'Construction de cloison'
    }
  },
} as const;

export function getServiceLabel(serviceId: keyof typeof RENOVATION_RATES, language: Language): string {
  return RENOVATION_RATES[serviceId].label[language];
}

export function getServiceDescription(serviceId: keyof typeof RENOVATION_RATES, language: Language): string | undefined {
  return RENOVATION_RATES[serviceId].description?.[language];
}